import http from '@/services/http';

/**
 * Flat, filterable, paginated listing of individual egreso payments
 * (`tbl_pagos_egresos`), one row per payment (not grouped by invoice).
 * Contract: GET /egresos/pagos, roles [1,2,8,9]. See design
 * `sdd/s9-tab-pagos-plano/design` for the full response envelope.
 */
export default {
  obtenerListado(filtros = {}) {
    return http.get('egresos/pagos', { params: filtros });
  },

  /**
   * Same endpoint, `export=true`. Ignores pagination server-side (returns
   * ALL rows matching the filters, not just the current page) and responds
   * with `{ success, file_url, msg }` instead of the listing envelope.
   */
  exportarListado(filtros = {}) {
    return http.get('egresos/pagos', { params: { ...filtros, export: true } });
  },

  /**
   * Anula un pago de egreso ya registrado. Requiere `verificarAdmin` (rol<3)
   * + roles [1,2,8,9]. Responde `{ success:true, message }`; el pago ya
   * anulado o inexistente responde 400/404 con `message`.
   */
  anularPago(id, motivo) {
    return http.post(`egresos/pagos/${id}/anular`, { motivo });
  },

  /**
   * Anula un egreso (factura). Misma proteccion de roles que anularPago.
   * El backend rechaza (400) anular un egreso que todavia tiene pagos
   * activos: "No se puede anular un egreso con pagos. Anule primero los
   * pagos." (egreso_service.anularEgreso) — no hay cascada de anulacion.
   */
  anularEgreso(id, motivo) {
    return http.post(`egresos/${id}/anular`, { motivo });
  },
};
